// import React, {useEffect} from 'react'
// import './css/LoginPage.css'
// import {Link, useHistory} from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import useHeaderOps from "../hooks/useHeaderOps";
// //import {version} from "../../../package.json";
// import {emptyCache} from "../../lib/js/jsUtil";
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from "axios";
// import packageInfo from "../../../package.json";

// {  /*
//     THIS WAS WRITTEM FOR BYPASS LOGIN
//     export default function LoginPage() {
//     const history = useHistory();

//     useEffect(() => {
//           Redirect the user to the dashboard
//           history.push("/dashboard");
//         }, []);

//     return null; // This component doesn't render anything
// */}

// export default function LoginPage(props) {

//     // used for redirection:
//     const history = useHistory()

//     // used for login related operations
//     const loginOps = useLoginOps(props)

//     // used for header related operations
//     const headerOps = useHeaderOps(props)

//     useEffect(()=>{
//         // if user is logged in
//         if(props.loginDetails!==null) {

//             // & projects are not set:
//              if(props.userProjects===null) {
//             //      fetch projects & activities of user
//                  // avoid, infinite try on dashboard while fail to fetch project/activities
//                  loginOps.fetchProjectsAndActivities()
//              } else {    // project & activities of user are set
//                // goto dashboard
//                 history.push("/dashboard")
//          }
//         }
//         // above operation happen when, login details or user projects are changed:
//     },[props.loginDetails,props.userProjects])

//     // using references to get email & password at login time. These refs are being
//     // used with HTML elements.
//     const emailInput = React.createRef()
//     const passInput = React.createRef()

//     // adding css 'login' class for custom css on this page
//     useEffect(()=>{
//         // setup (add)
//         document.body.classList.add("login")

//         // return function will execute when we move
//         // from login page to some other page
//         return ()=>{
//             // tear down (remove)
//             document.body.classList.remove("login")
//         }
//     })

//     const tryWithoutLogin = ()=> {
//         // set free activity related details in header data
//         headerOps.setFreeActivityHeader()
//         // open free-activity page
//         history.push("/free-activity")
//     }

//     // login/signUp using google auth

//     const googleAuthLogin = useGoogleLogin({
//         onSuccess: async respose => {
//             try {
//                 const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
//                     headers: {
//                         "Authorization": `Bearer ${respose.access_token}`
//                     }
//                 })
//                 // console.log(res.data, "email: ", res.data.email)
//                 if(res.data.email_verified){
//                     loginOps.loginUserGoogle(res.data.email)
//                 }
//                 else{
//                     props.toastSuccess("Error during Google signIn/Out, please try again")
//                 }
//             } catch (err) {
//                 // console.log(err)
//                 props.toastSuccess("Error during Google signIn/Out, please try again")
//             }
//         }
//     });

//     // when user click login
//     function handleLoginClick() {
//         // perform login operation:
//         loginOps.loginUser(emailInput.current.value,passInput.current.value)
//     }

//     function onClickCreateAccount() {
//         window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true","_blank")
//         // history.push("/signup-41251234123")
//     }

//     function onClickForgotPassword() {
//         // forget password feature will be available when email sending issue with https is fixed.
//         // alert("Password reset feature will be available soon.")

//         history.push("/forget-password")

//     }

//     // For : Test caching:
//     // useEffect(()=>{
//     //     props.toastInfo("Testing Cache Burst. Serial 2311321__4")
//     // })

//     // cache burst when user comes on login page:
//     useEffect(()=>{
//         async function fetchVersion() {
//             const cacheBurst = new Date().getTime()

//             let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
//             result = await result.json()
//             const oldVersion = packageInfo.version
//             const newVersion = result.version
//             if(oldVersion!==newVersion) {
//                 props.set_appVersion(result.version)
//                 emptyCache()
//             }
//         }
//         fetchVersion().then()
//     },[])

//     return (
//         <>
//             <header id="home-section">
//                 <div className="container-fluid h-100">
//                     <div className="row h-100">
//                         {/* process.env.PUBLIC_URL = points to the public directory of the project. */}
//                         <div className="col-lg-8 p-0 text-white cover_img" style={{backgroundImage:'url('+process.env.PUBLIC_URL + '/assets/images/web/geometric-1732847_960_720.webp)'}}>
//                             <div className="dark-overlay d-flex flex-column align-items-center justify-content-center">
//                                 <h1 className="display-4 my-5 mont_txt">AI Connect</h1>

//                                 <div id="slider4" className="container carousel slide mb-5" data-ride="carousel">
//                                     <ol className="carousel-indicators">
//                                         <li className="active" data-target="#slider4" data-slide-to="0"/>
//                                         <li data-target="#slider4" data-slide-to="1"/>
//                                         <li data-target="#slider4" data-slide-to="2"/>
//                                         <li data-target="#slider4" data-slide-to="3"/>
//                                     </ol>

//                                     {/* Moving Slider on Login Page  */}
//                                     <div className="carousel-inner">
//                                         <div className="carousel-item active">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Graphics
//                                                         Designing</h2>
//                                                     <ul className="desc2 p-3 mt-3 ml-3 poppins_txt">
//                                                         <li> Block based coding to learn Graphics Designing.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 50 + Graphics Designing Activities, more than 25 + Graphics
//                                                             Designing Projects.
//                                                         </li>
//                                                         <li> Draw your Imaginations & learn coding.</li>
//                                                         <li> Think Out of the box & draw your own graphics.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Graphics_Designing.png' }
//                                                          alt={"Graphics_Designing"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Basic
//                                                         Python</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> GUI based coding to learn Python Coding.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 100 + Basic Python Activities, more than 50 + Basic Python
//                                                             Projects.
//                                                         </li>
//                                                         <li> Draw your Imaginations & learn coding.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Basic_Python.png' }
//                                                          alt={"Basic_Python"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">Machine
//                                                         Learning</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> Train your own machine.</li>
//                                                         <li> Test & Develop cases for your machine.</li>
//                                                         <li> Deploy your own predictive learning.</li>
//                                                         <li> Learn Block Coding & Python Coding.</li>
//                                                         <li> 50 + Machine Learning projects.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/Machine_Learning.png' }
//                                                          alt={"Machine_Learning"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="carousel-item">
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-6">
//                                                     <h2 className="title2 mb-5 text-center poppins_txt">AI Real
//                                                         World</h2>
//                                                     <ul className="desc2 p-3 pt-5 mt-3 ml-3 poppins_txt">
//                                                         <li> Learn to detect & recognize human faces.</li>
//                                                         <li> Learn to recognize objects.</li>
//                                                         <li> Learn to recognize color & many more.</li>
//                                                         <li> Integration of AI with hardware .</li>
//                                                         <li> 50 + Artificial Intelligence projects.</li>
//                                                     </ul>
//                                                 </div>
//                                                 <div className="col-md-4 d-flex">
//                                                     <img className="img-fluid py-3 w-75 m-auto"
//                                                          src={process.env.PUBLIC_URL + '/assets/images/web/AI_Real_World.png' }
//                                                          alt={"AI_Real_World"}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                     </div>

//                                     <a href="#slider4" className="carousel-control-prev" data-slide="prev">
//                                         <span className="carousel-control-prev-icon"/>
//                                     </a>

//                                     <a href="#slider4" className="carousel-control-next" data-slide="next">
//                                         <span className="carousel-control-next-icon"/>
//                                     </a>
//                                 </div>

//                             </div>
//                         </div>

//                         <div className="col-lg-4 d-flex flex-column align-items-center justify-content-center"
//                              style={{backgroundColor: "White" }}>
//                             {/* <img id="com_logo" src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png' } className="img-fluid mt-5 mb-3"
//                                  width="220px" alt={"stemrobo_logo"}/> */}

//                             <img
//                              id="com_logo"
//                              src={process.env.PUBLIC_URL + '/assets/images/web/stemrobo_logo.png'}
//                              className="img-fluid mt-5 mb-3"
//                              style={{ width: '280px', height: 'auto' }}
//                              alt={"stemrobo_logo"}
//                             />

//                             <form>
//                                 <h3 className="text-center ai_h2 my-5">Login to Continue</h3>
//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text">@</span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="email" type="email"
//                                            maxLength="150"
//                                            placeholder="Email-Id"
//                                            ref={emailInput}
//                                         // value={"ankit.kumar@tevatrontech.org"}
//                                     />
//                                 </div>

//                                 <div className="input-group mb-3">
//                                     <div className="input-group-prepend">
//                                         <span className="input-group-text"><i className="fa fa-lock" /> </span>
//                                     </div>
//                                     <input className="form-control mont_input1" name="password" type="password"
//                                            maxLength="50"
//                                            placeholder="Password"
//                                            ref={passInput}
//                                         // value={"md5pass"}
//                                     />
//                                 </div>
//                                 <div className="d-flex px-3">
//                                     <div className="checkbox mr-auto invisible">
//                                     </div>
//                                     <span id="frgt_pass" onClick={ onClickForgotPassword } className="btn-link mont_txt txt_sm" style={{cursor: "pointer" }}>Forget Password?</span>
//                                 </div>

//                                 {/* Remove below div, when create account is enabled. */}

//                                 {/*<div className="d-flex justify-content-around my-5">*/}
//                                 {/*    <button id="btn_login" className="bt1 btn btn-primary" type="button" onClick={ handleLoginClick }>Login</button>*/}
//                                 {/*</div>*/}

//                                 <div className="btn-toolbar justify-content-between" role="toolbar"
//                                      aria-label="Toolbar with button groups">
//                                     <div className="btn-group" role="group" aria-label="First group">
//                                         <div className="d-flex justify-content-around-1 my-4">
//                                             <button id="btn_login" className="bt1 btn btn-primary" type="button" onClick={ handleLoginClick }>Login</button>
//                                         </div>
//                                     </div>
//                                     <div className="input-group">
//                                         <div className="d-flex justify-content-around my-4">
//                                             <button id="btn_login" style={{'background-color':'green','color':'white'}} className="bt1 btn btn-light" type="button" onClick={ onClickCreateAccount }>Request a Callback</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div class="hr-div">
//                                     <hr class="hr-two-divider" style={{ "margin": "24px 0px" }}></hr>
//                                     <div class="hr-middle-text">or</div>
//                                     <hr class="hr-two-divider" style={{ "margin": "24px 0px" }}></hr>
//                                 </div>

//                                     <div className="d-flex justify-content-around my-3">
//                                     <button id="btn_google_login" className="bt1 btn btn-primary btn-transparent" type="button" onClick={googleAuthLogin}>
//                                     <img style={{height: "1.5rem", marginBottom: "0.2rem"}} src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}/>  Continue with google
//                                     </button>
//                                 </div>
//                                 <hr />
//                             </form>
//                             <br/>
//                             <Link onClick={ tryWithoutLogin } className="mb-5">Try without login &rarr;</Link>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//         </>
//     )
// }

// import React, {useEffect} from 'react'
// import './css/LoginPage.css'
// import {Link, useHistory} from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import useHeaderOps from "../hooks/useHeaderOps";
// import {emptyCache} from "../../lib/js/jsUtil";
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from "axios";
// import packageInfo from "../../../package.json";

// export default function LoginPage(props) {
//     const history = useHistory()
//     const loginOps = useLoginOps(props)
//     const headerOps = useHeaderOps(props)

//     useEffect(()=>{
//         if(props.loginDetails!==null) {
//              if(props.userProjects===null) {
//                  loginOps.fetchProjectsAndActivities()
//              } else {
//                 history.push("/dashboard")
//          }
//         }
//     },[props.loginDetails,props.userProjects])

//     const emailInput = React.createRef()
//     const passInput = React.createRef()

//     useEffect(()=>{
//         document.body.classList.add("login")
//         return ()=>{
//             document.body.classList.remove("login")
//         }
//     })

//     const tryWithoutLogin = ()=> {
//         headerOps.setFreeActivityHeader()
//         history.push("/free-activity")
//     }

//     const googleAuthLogin = useGoogleLogin({
//         onSuccess: async respose => {
//             try {
//                 const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
//                     headers: {
//                         "Authorization": `Bearer ${respose.access_token}`
//                     }
//                 })
//                 if(res.data.email_verified){
//                     loginOps.loginUserGoogle(res.data.email)
//                 }
//                 else{
//                     props.toastSuccess("Error during Google signIn/Out, please try again")
//                 }
//             } catch (err) {
//                 props.toastSuccess("Error during Google signIn/Out, please try again")
//             }
//         }
//     });

//     function handleLoginClick() {
//         loginOps.loginUser(emailInput.current.value,passInput.current.value)
//     }

//     function onClickCreateAccount() {
//         window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true","_blank")
//     }

//     function onClickForgotPassword() {
//         history.push("/forget-password")
//     }

//     useEffect(()=>{
//         async function fetchVersion() {
//             const cacheBurst = new Date().getTime()
//             let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
//             result = await result.json()
//             const oldVersion = packageInfo.version
//             const newVersion = result.version
//             if(oldVersion!==newVersion) {
//                 props.set_appVersion(result.version)
//                 emptyCache()
//             }
//         }
//         fetchVersion().then()
//     },[])

//     return (
//         <>
//             <header id="home-section" className="login-bg">
//                 <div className="container-fluid h-100">
//                     <div className="row h-100 justify-content-center align-items-center">
//                         {/* Centered Login Form */}
//                         <div className="col-12 col-md-6 col-lg-5 col-xl-4">
//                             <div className="login-form-container p-4 p-md-5">
//                                 <div className="text-center mb-5">
//                                     <img
//                                         src={process.env.PUBLIC_URL + 'assets/images/web/orange-logo.png'}
//                                         alt="Orange AI Logo"
//                                         className="img-fluid mb-4"
//                                         style={{maxWidth: "220px"}}
//                                     />
//                                     <h2 className="mb-3" style={{color: "#FF7F00", fontWeight: '600'}}>Welcome to Orange AI</h2>
//                                     <p className="text-muted">Sign in to continue your learning journey</p>
//                                 </div>

//                                 <form className="mb-4">
//                                     <div className="form-group mb-4">
//                                         <div className="input-group">
//                                             <div className="input-group-prepend">
//                                                 <span className="input-group-text bg-white border-right-0">
//                                                     <i className="fas fa-envelope text-secondary"></i>
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 className="form-control py-3 border-left-0"
//                                                 name="email"
//                                                 type="email"
//                                                 maxLength="150"
//                                                 placeholder="Email address"
//                                                 ref={emailInput}
//                                                 style={{borderRadius: "0 8px 8px 0"}}
//                                             />
//                                         </div>
//                                     </div>

//                                     <div className="form-group mb-4">
//                                         <div className="input-group">
//                                             <div className="input-group-prepend">
//                                                 <span className="input-group-text bg-white border-right-0">
//                                                     <i className="fas fa-lock text-secondary"></i>
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 className="form-control py-3 border-left-0"
//                                                 name="password"
//                                                 type="password"
//                                                 maxLength="50"
//                                                 placeholder="Password"
//                                                 ref={passInput}
//                                                 style={{borderRadius: "0 8px 8px 0"}}
//                                             />
//                                         </div>
//                                     </div>

//                                     {/* <div className="d-flex justify-content-end mb-4">
//                                         <span
//                                             onClick={onClickForgotPassword}
//                                             className="text-primary cursor-pointer"
//                                             style={{fontSize: '0.9rem', fontWeight: '500'}}
//                                         >
//                                             Forgot Password?
//                                         </span>
//                                     </div> */}

//                                     <button
//                                         id="btn_login"
//                                         className="btn btn-primary btn-block py-3 mb-4"
//                                         type="button"
//                                         onClick={handleLoginClick}
//                                         style={{
//                                             backgroundColor: "#FF7F00",
//                                             borderColor: "#FF7F00",
//                                             borderRadius: "8px",
//                                             fontWeight: "600",
//                                             fontSize: "1.1rem"
//                                         }}
//                                     >
//                                         Sign In
//                                     </button>
//                                 </form>

//                                 {/* <div className="divider d-flex align-items-center mb-4">
//                                     <div className="border-top flex-grow-1"></div>
//                                     <span className="px-3 text-muted">or</span>
//                                     <div className="border-top flex-grow-1"></div>
//                                 </div> */}
// {/*
//                                 <button
//                                     id="btn_google_login"
//                                     className="btn btn-light btn-block py-3 mb-4 d-flex align-items-center justify-content-center"
//                                     type="button"
//                                     onClick={googleAuthLogin}
//                                     style={{
//                                         border: "1px solid #ddd",
//                                         borderRadius: "8px",
//                                         fontWeight: "500"
//                                     }}
//                                 >
//                                     <img
//                                         style={{height: "1.5rem", marginRight: "0.75rem"}}
//                                         src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}
//                                         alt="Google"
//                                     />
//                                     Continue with Google
//                                 </button> */}

//                                 {/* <div className="text-center mt-4 mb-4">
//                                     <p className="text-muted mb-0">Don't have an account?</p>
//                                     <button
//                                         className="btn btn-link p-0"
//                                         onClick={onClickCreateAccount}
//                                         style={{color: "#FF7F00", fontWeight: "500"}}
//                                     >
//                                         Request a callback
//                                     </button>
//                                 </div> */}

//                                 {/* <div className="text-center mt-4">
//                                     <span
//                                         onClick={tryWithoutLogin}
//                                         className="text-primary cursor-pointer"
//                                         style={{fontWeight: "500"}}
//                                     >
//                                         Try without login &rarr;
//                                     </span>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//         </>
//     )
// }

// import React, {useEffect} from 'react'
// import './css/LoginPage.css'
// import {Link, useHistory} from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import useHeaderOps from "../hooks/useHeaderOps";
// import {emptyCache} from "../../lib/js/jsUtil";
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from "axios";
// import packageInfo from "../../../package.json";

// export default function LoginPage(props) {
//     const history = useHistory()
//     const loginOps = useLoginOps(props)
//     const headerOps = useHeaderOps(props)

//     useEffect(()=>{
//         if(props.loginDetails!==null) {
//              if(props.userProjects===null) {
//                  loginOps.fetchProjectsAndActivities()
//              } else {
//                 history.push("/dashboard")
//          }
//         }
//     },[props.loginDetails,props.userProjects])

//     const emailInput = React.createRef()
//     const passInput = React.createRef()

//     useEffect(()=>{
//         document.body.classList.add("login")
//         return ()=>{
//             document.body.classList.remove("login")
//         }
//     })

//     const tryWithoutLogin = ()=> {
//         headerOps.setFreeActivityHeader()
//         history.push("/free-activity")
//     }

//     const googleAuthLogin = useGoogleLogin({
//         onSuccess: async respose => {
//             try {
//                 const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
//                     headers: {
//                         "Authorization": `Bearer ${respose.access_token}`
//                     }
//                 })
//                 if(res.data.email_verified){
//                     loginOps.loginUserGoogle(res.data.email)
//                 }
//                 else{
//                     props.toastSuccess("Error during Google signIn/Out, please try again")
//                 }
//             } catch (err) {
//                 props.toastSuccess("Error during Google signIn/Out, please try again")
//             }
//         }
//     });

//     function handleLoginClick() {
//         loginOps.loginUser(emailInput.current.value,passInput.current.value)
//     }

//     function onClickCreateAccount() {
//         window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true","_blank")
//     }

//     function onClickForgotPassword() {
//         history.push("/forget-password")
//     }

//     useEffect(()=>{
//         async function fetchVersion() {
//             const cacheBurst = new Date().getTime()
//             let result = await fetch(`${process.env.PUBLIC_URL}/meta.json?`+cacheBurst)
//             result = await result.json()
//             const oldVersion = packageInfo.version
//             const newVersion = result.version
//             if(oldVersion!==newVersion) {
//                 props.set_appVersion(result.version)
//                 emptyCache()
//             }
//         }
//         fetchVersion().then()
//     },[])

//     return (
//         <>
//             <header id="home-section" className="login-container">
//                 <div className="container-fluid h-100">
//                     <div className="row h-100">
//                         {/* Left side with AI coding image */}
//                         <div className="col-lg-7 d-none d-lg-block p-0">
//                             <div className="ai-coding-image h-100">
//                                 <div className="image-overlay d-flex flex-column justify-content-center p-5">
//                                     <h1 className="display-4 mb-4 text-white">OrangeAI</h1>
//                                     <p className="lead mb-4">Empowering the next generation of innovators with AI and coding education</p>
//                                     <div className="features-list">
//                                         <div className="feature-item d-flex align-items-center mb-3">
//                                             <i className="fas fa-code fa-2x mr-3"></i>
//                                             <span>Learn Block-based Python programming</span>
//                                         </div>
//                                         <div className="feature-item d-flex align-items-center mb-3">
//                                             <i className="fas fa-brain fa-2x mr-3"></i>
//                                             <span>Hands-on AI and Machine learning projects</span>
//                                         </div>
//                                         <div className="feature-item d-flex align-items-center">
//                                             <i className="fas fa-lightbulb fa-2x mr-3"></i>
//                                             <span>Bring your ideas to life with code</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Right side with login form */}
//                         <div className="col-lg-5 col-md-12 d-flex flex-column align-items-center justify-content-center bg-light">
//                             <div className="login-form-container w-100 px-4 px-md-5">
//                                 <div className="text-center mb-5">
//                                     <img
//                                         src={process.env.PUBLIC_URL + '/assets/images/web/orange_updated_logo.png'}
//                                         alt="Orange AI Logo"
//                                         className="img-fluid mb-4"
//                                         style={{maxWidth: "220px"}}
//                                     />
//                                     <h2 className="mb-3" style={{color: "#FF7F00", fontWeight: '600'}}>Welcome Back</h2>
//                                     <p className="text-muted">Sign in to continue your learning journey</p>
//                                 </div>

//                                 <form className="mb-4">
//                                     <div className="form-group mb-4">
//                                         <div className="input-group">
//                                             <div className="input-group-prepend">
//                                                 <span className="input-group-text bg-white border-right-0">
//                                                     <i className="fas fa-envelope text-secondary"></i>
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 className="form-control py-3 border-left-0"
//                                                 name="email"
//                                                 type="email"
//                                                 maxLength="150"
//                                                 placeholder="Email address"
//                                                 ref={emailInput}
//                                                 style={{borderRadius: "0 8px 8px 0"}}
//                                             />
//                                         </div>
//                                     </div>

//                                     <div className="form-group mb-4">
//                                         <div className="input-group">
//                                             <div className="input-group-prepend">
//                                                 <span className="input-group-text bg-white border-right-0">
//                                                     <i className="fas fa-lock text-secondary"></i>
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 className="form-control py-3 border-left-0"
//                                                 name="password"
//                                                 type="password"
//                                                 maxLength="50"
//                                                 placeholder="Password"
//                                                 ref={passInput}
//                                                 style={{borderRadius: "0 8px 8px 0"}}
//                                             />
//                                         </div>
//                                     </div>

//                                     {/* <div className="d-flex justify-content-end mb-4">
//                                         <span
//                                             onClick={onClickForgotPassword}
//                                             className="text-primary cursor-pointer"
//                                             style={{fontSize: '0.9rem', fontWeight: '500'}}
//                                         >
//                                             Forgot Password?
//                                         </span>
//                                     </div> */}

//                                     <button
//                                         id="btn_login"
//                                         className="btn btn-primary btn-block py-3 mb-4"
//                                         type="button"
//                                         onClick={handleLoginClick}
//                                         style={{
//                                             backgroundColor: "#FF7F00",
//                                             borderColor: "#FF7F00",
//                                             borderRadius: "8px",
//                                             fontWeight: "600",
//                                             fontSize: "1.1rem"
//                                         }}
//                                     >
//                                         Sign In
//                                     </button>
//                                 </form>

//                                 {/* <div className="divider d-flex align-items-center mb-4">
//                                     <div className="border-top flex-grow-1"></div>
//                                     <span className="px-3 text-muted">or</span>
//                                     <div className="border-top flex-grow-1"></div>
//                                 </div> */}

//                                 {/* <button
//                                     id="btn_google_login"
//                                     className="btn btn-light btn-block py-3 mb-4 d-flex align-items-center justify-content-center"
//                                     type="button"
//                                     onClick={googleAuthLogin}
//                                     style={{
//                                         border: "1px solid #ddd",
//                                         borderRadius: "8px",
//                                         fontWeight: "500"
//                                     }}
//                                 >
//                                     <img
//                                         style={{height: "1.5rem", marginRight: "0.75rem"}}
//                                         src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}
//                                         alt="Google"
//                                     />
//                                     Continue with Google
//                                 </button> */}

//                                 {/* <div className="text-center mt-4 mb-4">
//                                     <p className="text-muted mb-0">Don't have an account?</p>
//                                     <button
//                                         className="btn btn-link p-0"
//                                         onClick={onClickCreateAccount}
//                                         style={{color: "#FF7F00", fontWeight: "500"}}
//                                     >
//                                         Request a callback
//                                     </button>
//                                 </div>

//                                 <div className="text-center mt-4">
//                                     <span
//                                         onClick={tryWithoutLogin}
//                                         className="text-primary cursor-pointer"
//                                         style={{fontWeight: "500"}}
//                                     >
//                                         Try without login &rarr;
//                                     </span>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//         </>
//     )
// }




// LoginPage.jsx
import React, { useEffect, useState, useRef } from "react";
import "./css/LoginPage.css";
import logo from "../component/Orange_logo.png";
import orangeAI from "../component/OrangeAI_Logo.png";

import { useHistory } from "react-router-dom";
import useLoginOps from "../hooks/useLoginOps";
import useHeaderOps from "../hooks/useHeaderOps";
import { emptyCache } from "../../lib/js/jsUtil";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import packageInfo from "../../../package.json";

const LoginPage = (props) => {
  const history = useHistory();
  const loginOps = useLoginOps(props);
  const headerOps = useHeaderOps(props);

  const [expandedCards, setExpandedCards] = useState({});
  const [isDark, setIsDark] = useState(false);

  // refs for inputs (to match previous API)
  const emailInput = useRef(null);
  const passInput = useRef(null);

  // Initialize theme from body class
  useEffect(() => {
    const isDarkMode = document.body.classList.contains("dark");
    setIsDark(isDarkMode);
  }, []);




// useEffect(() => {
//   // Ensure light theme by default
//   document.body.classList.remove("dark");
//   setIsDark(false);

//   return () => {
//     // Cleanup when leaving login page (dashboard)
//     document.body.classList.remove("dark");
//   };
// }, []);


// Initialize dark theme on mount
useEffect(() => {
  document.body.classList.add("dark"); // Set dark theme
  setIsDark(true);

  return () => {
    // Cleanup when leaving login page
    document.body.classList.remove("dark");
  };
}, []);


// Toggle theme for login page only
const toggleTheme = () => {
  document.body.classList.toggle("dark"); // matches your CSS for dark theme
  setIsDark(!isDark);
}



  // Manage body class 'login' similar to original behaviour if needed
  useEffect(() => {
    document.body.classList.add("login");
    return () => {
      document.body.classList.remove("login");
    };
  }, []);

  // Redirect / fetch projects if already logged in (preserves original behavior)
  useEffect(() => {
    if (props.loginDetails !== null) {
      if (props.userProjects === null) {
        loginOps.fetchProjectsAndActivities();
      } else {
        history.push("/dashboard");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loginDetails, props.userProjects]);

//   const toggleTheme = () => {
//     document.body.classList.toggle("dark");
//     setIsDark(!isDark);
//   };


  const handleShowMore = (index) => {
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Try without login (preserve original)
  const tryWithoutLogin = () => {
    headerOps.setFreeActivityHeader();
    history.push("/free-activity");
  };

  // Create account callback (preserve original)
  function onClickCreateAccount() {
    window.open(
      "https://forms.office.com/Pages/ResponsePage.aspx?id=0MsZjfXntUu1QNND29n9aCs6dQCEBZxIocOLPfbNKIdUREs3WkNBMEhRVTRSRjEyQkg1SVFQOTNDVy4u&embed=true",
      "_blank"
    );
  }

  function onClickForgotPassword() {
    history.push("/forget-password");
  }

  // Google OAuth login (preserve original)
  const googleAuthLogin = useGoogleLogin({
    onSuccess: async (respose) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${respose.access_token}`,
            },
          }
        );
        if (res.data.email_verified) {
          loginOps.loginUserGoogle(res.data.email);
        } else {
          props.toastSuccess &&
            props.toastSuccess(
              "Error during Google signIn/Out, please try again"
            );
        }
      } catch (err) {
        props.toastSuccess &&
          props.toastSuccess(
            "Error during Google signIn/Out, please try again"
          );
      }
    },
  });

  // Handle normal login click
  function handleLoginClick() {
    const email = emailInput.current ? emailInput.current.value : "";
    const pass = passInput.current ? passInput.current.value : "";
    loginOps.loginUser(email, pass);
  }

  // Fetch version check (preserve original)
  useEffect(() => {
    async function fetchVersion() {
      try {
        const cacheBurst = new Date().getTime();
        let result = await fetch(
          `${process.env.PUBLIC_URL}/meta.json?` + cacheBurst
        );
        result = await result.json();
        const oldVersion = packageInfo.version;
        const newVersion = result.version;
        if (oldVersion !== newVersion) {
          props.set_appVersion && props.set_appVersion(result.version);
          emptyCache();
        }
      } catch (e) {
        // silent fail — keep original behavior
      }
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-page">
             {/* === ADD THESE TWO LINES HERE === */}
      <div className="side-anim left"></div>
      <div className="side-anim right"></div>
    
      {/* Logo */}
      <div className="site-logo">
        <img src={logo} alt="Orange Logo" />
      </div>

      {/* Theme Toggle */}
      <button
        className="theme-toggle"
        onClick={toggleTheme}
        aria-label="Toggle theme"
      >
        {isDark ? "🌙" : "🔆"}
      </button>

      {/* Left Vertical Courses */}
      <div className="vertical-cards left">
        <div className="scroll-container-left">
          {[
            {
              title: "Core Coding",
              desc: "Learn Python foundations step-y-step.",
            },
            {
              title: "AI Coding",
              desc: "Unlock ML + AI through coding challenges.",
            },
           
            {
              title: "Scratch Coding",
              desc: "Explore ML and AI with Scratch coding.",
            },
           
            {
              title: "Core Coding",
              desc: "Learn Python foundations step-by-step.",
            },
            {
              title: "AI Coding",
              desc: "Unlock ML + AI through coding challenges.",
            },
          ].map((c, i) => (
            <div key={i} className="course-card">
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}

          {/* Duplicate for infinite loop */}
          {[
            {
              title: "Core Coding",
              desc: "Learn Python foundations step-by-step.",
            },
            {
              title: "AI Coding",
              desc: "Unlock ML + AI through coding challenges.",
            },
           
            {
              title: "Scratch Coding",
              desc: "Explore ML and AI with Scratch coding.",
            },
            
            {
              title: "Core Coding",
              desc: "Learn Python foundations step-by-step.",
            },
            {
              title: "AI Coding",
              desc: "Unlock ML + AI through coding challenges.",
            },
          ].map((c, i) => (
            <div key={`dup-left-${i}`} className="course-card">
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Right Vertical Courses */}
      <div className="vertical-cards right">
        <div className="scroll-container-right">
          {[
            {
              title: "MIT App Inventor",
              desc: "Create your own apps & games.",
            },
            {
              title: "Blocky Games",
              desc: "Code, play, and learn in a playful way.",
            },
            {
              title: "Jupyter Notebook",
              desc: "Explore real-world data & experiments.",
            },
            {
              title: "Java Coding",
              desc: "Compile & conquer Java the smart way.",
            },
            { title: "MakeCode Arcade", desc: "Turn ideas into games." },
          ].map((c, i) => (
            <div key={i} className="course-card">
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}

          {/* Duplicate for infinite loop */}
          {[
            {
              title: "MIT App Inventor",
              desc: "Create your own apps & games.",
            },
            {
              title: "Blocky Games",
              desc: "Code, play, and learn in a playful way.",
            },
            {
              title: "Jupyter Notebook",
              desc: "Explore real-world data & experiments.",
            },
            {
              title: "Java Coding",
              desc: "Compile & conquer Java the smart way.",
            },
            { title: "MakeCode Arcade", desc: "Turn ideas into games." },
          ].map((c, i) => (
            <div key={`dup-right-${i}`} className="course-card">
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Center Content */}
      <main className="center">
        {/* OrangeAI Info */}
        <section className="info">
          <h1 className="logo-heading">
            <img src={orangeAI} alt="OrangeAI" /> OrangeAI
          </h1>
          <p>
            A unified platform teaching Coding, AI, and ML through block,
            hybrid, and text-based learning.
          </p>
        </section>

        {/* Top Feature Cards */}
        {/* <div className="feature-cards">
          {[
            {
              title: "Graphics & Design",
              desc: "Learn block-based coding to design graphics.",
            },
            {
              title: "AI in the Real World",
              desc: "Detect and recognise faces, objects, colours.",
            },
            {
              title: "Python for Beginners",
              desc: "Learn Python with GUI and block-to-code.",
            },
            { title: "ML for Kids", desc: "Train your own models." },
          ].map((f, i) => (
            <div key={i} className="feature-card">
              <h3>{f.title}</h3>
              <p>{f.desc}</p>

              {/* Extra content shown only when expanded */}
              {/* {expandedCards[i] && (
                <div className="more-content">
                  <p>{f.title}...</p>
                </div>
              )} */}

              {/* <button className="explore-btn" onClick={() => handleShowMore(i)}>
                {expandedCards[i] ? "Show less" : "Explore more..."}
              </button>
            </div> */}
    {/* Top Feature Cards */}
<div className="feature-cards">
  {[
    {
      title: "Graphics & Design",
      desc: [
        "Learn block-based coding to design graphics.",
        "Move from blocks to Python smoothly.",
        "50+ activities and 25+ projects in graphic design.",
        "Explore digital art, animation, and storytelling.",
        "Bonus: Game graphics & character design modules.",
      ],
    },
    {
      title: "AI in the Real World",
      desc: [
        "Detect and recognise faces, objects, and colours.",
        "Explore computer vision, voice recognition, and sentiment analysis.",
        "Hands-on integration with hardware and IoT.",
        "50+ AI projects.",
        "Bonus: Chatbots, recommendations, smart assistants.",
      ],
    },
    {
      title: "Python for Beginners",
      desc: [
        "Learn Python with GUI and block-to-code transition.",
        "100+ activities and 50+ projects.",
        "Focus on logic, problem-solving, and creativity.",
        "Bonus: Mini-apps, calculators, automation.",
      ],
    },
    {
      title: "ML for Kids",
      desc: [
        "Train your own models.",
        "Build and test predictive cases.",
        "Real-time ML projects (stock, health, chatbots).",
        "Block coding and Python-based ML.",
        "50+ ML projects.",
      ],
    },
  ].map((f, i) => (
    <div key={i} className="feature-card">
      <h3>{f.title}</h3>
      {/* Show first point as preview */}
      <p>{f.desc[0]}</p>

      {/* Extra content shown only when expanded */}
      {expandedCards[i] && (
        <ul className="more-content">
          {f.desc.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>
      )}

      <button
        className="explore-btn"
        onClick={() => handleShowMore(i)}
      >
        {expandedCards[i] ? "Show less" : "Explore more..."}
      </button>
    </div>
  ))}
</div>

          {/* ))}
        </div> */} 

        {/* Login Card */}
        <div className="login-card">
          <h2>Login to Continue</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleLoginClick();
            }}
          >
            <div className="field">
              <input
                type="email"
                placeholder="Email address"
                required
                ref={emailInput}
                maxLength={150}
              />
            </div>
            <div className="field">
              <input
                type="password"
                placeholder="Password"
                required
                ref={passInput}
                maxLength={50}
              />
            </div>
        
            <div className="actions">
              <button className="btn-primary" type="submit">
                Login
              </button>
            </div>
          </form>

          {/* Keep commented UI parts from your original code (as requested) */}
          {/*
            <div className="divider d-flex align-items-center mb-4">
                <div className="border-top flex-grow-1"></div>
                <span className="px-3 text-muted">or</span>
                <div className="border-top flex-grow-1"></div>
            </div>

            <button
                id="btn_google_login"
                className="btn btn-light btn-block py-3 mb-4 d-flex align-items-center justify-content-center"
                type="button"
                onClick={googleAuthLogin}
                style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontWeight: "500"
                }}
            >
                <img
                    style={{height: "1.5rem", marginRight: "0.75rem"}}
                    src={process.env.PUBLIC_URL + '/assets/images/web/google-icon.png'}
                    alt="Google"
                />
                Continue with Google
            </button>

            <div className="text-center mt-4 mb-4">
                <p className="text-muted mb-0">Don't have an account?</p>
                <button
                    className="btn btn-link p-0"
                    onClick={onClickCreateAccount}
                    style={{color: "#FF7F00", fontWeight: "500"}}
                >
                    Request a callback
                </button>
            </div>

            <div className="text-center mt-4">
                <span
                    onClick={tryWithoutLogin}
                    className="text-primary cursor-pointer"
                    style={{fontWeight: "500"}}
                >
                    Try without login &rarr;
                </span>
            </div>
          */}
        </div>

        <div className="txt">
          <p>
            1000+ activities and projects across coding, AI, ML, robotics, and
            STEM. Blended curriculum from block-based coding to real Python/Java
            coding. Aligned with NEP 2020 and NCFSE 2023. Suitable for Classes
            1–12, with teacher-friendly dashboards and analytics. Gamified,
            project-based, and outcome-focused learning.
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
